var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('div',{class:_vm.customizeLoader},[_c('div',{class:_vm.width})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }